(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["choose-rev-tent"]) return;
  try {
    
  const tent = document.querySelectorAll('.choose-rev-tent-content .tents li a');
  for(let i = 0; i < tent.length; i++){
    const linkTarget = tent[i].getAttribute('href').substring(1);
      tent[i].addEventListener('click', function(e) {
          e.preventDefault();
          const targetSection = document.getElementById(linkTarget);
          if (targetSection) {
            const targetPosition = targetSection.getBoundingClientRect().top + window.pageYOffset - 114;
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
          }
      });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template-v2"]) return;
  try {
    
    const vw = window.innerWidth || document.documentElement.clientWidth;
    const bannerVideo = document.querySelector('.collection-video-banner video');
    const desktopMobile = bannerVideo.getAttribute('data-desktop');
    const mobileMobile = bannerVideo.getAttribute('data-mobile');
    vw < 768 ? bannerVideo.innerHTML = `<source src="${mobileMobile}" type="video/mp4" class="mobile" />` : bannerVideo.innerHTML = `<source src="${desktopMobile}" type="video/mp4" class="desktop" />`;
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tent"]) return;
  try {
    
    const vw = window.innerWidth || document.documentElement.clientWidth;
    const bannerVideo = document.querySelector('.collection-video-banner video');
    const desktopMobile = bannerVideo.getAttribute('data-desktop');
    const mobileMobile = bannerVideo.getAttribute('data-mobile');
    vw < 768 ? bannerVideo.innerHTML = `<source src="${mobileMobile}" type="video/mp4" class="mobile" />` : bannerVideo.innerHTML = `<source src="${desktopMobile}" type="video/mp4" class="desktop" />`;
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-shop-rev"]) return;
  try {
    
  $('.rev-tents-wrapper .tent .owl-carousel').owlCarousel({
    items: 1,
    nav: true
  });

  } catch(e) { console.error(e); }
})();
})();
